import { Card, Layout, Typography } from 'antd';
import type { ReactNode } from 'react';

/** Centered card shell for unauthenticated screens (login, register, reset, …). */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <Layout
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
      }}
    >
      <Card style={{ width: '100%', maxWidth: 420 }} styles={{ body: { padding: 32 } }}>
        <Typography.Title level={3} style={{ marginBottom: 4 }}>
          {title}
        </Typography.Title>
        {subtitle ? (
          <Typography.Paragraph type="secondary" style={{ marginBottom: 24 }}>
            {subtitle}
          </Typography.Paragraph>
        ) : null}
        {children}
        {footer ? <div style={{ marginTop: 24, textAlign: 'center' }}>{footer}</div> : null}
      </Card>
    </Layout>
  );
}
